// The avatars a player can pick (one profile, used in every mode), grouped
// into the picker's tabs. The server only accepts these, so nothing else can
// be shown to other players. Single-codepoint emoji from Emoji 13 or older
// only (no skin tones, ZWJ sequences or variation selectors), so they render
// the same on older phones.
export const AVATAR_GROUPS = [
    {
        key: 'animals', label: 'Animals', icon: '🐾',
        avatars: [
            '🦊', '🐼', '🦉', '🐙', '🦄', '🐯', '🐸', '🦖', '🐧', '🦁', '🐨', '🐵',
            '🦋', '🐳', '🐢', '🦈', '🐲', '🦩', '🐝', '🦝', '🐶', '🐱', '🐭', '🐹',
            '🐰', '🐻', '🐮', '🐷', '🐔', '🦆', '🦅', '🦇', '🐺', '🐗', '🐴', '🦓',
            '🦒', '🦘', '🦥', '🦦', '🦨', '🦔', '🦜', '🦚', '🦢', '🐊', '🦎', '🐍',
            '🦕', '🐡', '🐠', '🐬', '🦭', '🦑', '🦀', '🦞', '🐌', '🐞', '🦂', '🐘',
            '🦛', '🦏', '🐪', '🦙',
        ],
    },
    {
        key: 'characters', label: 'Characters', icon: '👾',
        avatars: [
            '👽', '🤖', '👻', '🧠', '👾', '🤡', '💀', '🎃', '😈', '👹', '👺', '🧛',
            '🧙', '🧚', '🧜', '🧞', '🦸', '🦹', '🥷', '🤠', '😎', '🤓', '🥸', '🤯',
            '🥶', '🥵', '😴', '🤪', '🧐', '😺', '🙈', '🤩',
        ],
    },
    {
        key: 'food', label: 'Food', icon: '🍕',
        avatars: [
            '🍕', '🍔', '🌮', '🍩', '🍪', '🧁', '🍦', '🍿', '🥑', '🍉', '🍓', '🍒',
            '🍍', '🥥', '🍋', '🥨', '🧀', '🥐', '🍣', '🍜', '🥟', '🧋', '🍫', '🍭',
        ],
    },
    {
        key: 'play', label: 'Play', icon: '🏆',
        avatars: [
            '⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏓', '🏸', '🥊', '🎱', '🎯', '🎳',
            '🏆', '🥇', '🎮', '🎲', '🧩', '🎸', '🎺', '🥁', '🎧', '🎤', '🛹', '🚀',
        ],
    },
    {
        key: 'magic', label: 'Magic', icon: '✨',
        avatars: [
            '🌈', '⚡', '🔥', '🌙', '⭐', '🌟', '🪐', '🌋', '🌊', '🌵', '🌻', '🍄',
            '🌸', '🍀', '💎', '👑', '🔮', '🧿', '🪄', '🎩', '🛸', '🌍', '💡', '🗿',
        ],
    },
];
export const PLAYER_AVATARS = AVATAR_GROUPS.flatMap(g => g.avatars);
export function isPlayerAvatar(value) {
    return typeof value === 'string' && PLAYER_AVATARS.includes(value);
}
// The original 24. Defaults are drawn from these only, so adding avatars never
// changes the one a player (or a rival) already shows without having picked.
const DEFAULT_AVATARS = [
    '🦊', '🐼', '🦉', '🐙', '🦄', '🐯', '🐸', '🦖', '🐧', '🦁', '🐨', '🐵',
    '🦋', '🐳', '🐢', '🦈', '🐲', '🦩', '🐝', '🦝', '👽', '🤖', '👻', '🧠',
];
// Stable default for someone who hasn't picked one yet.
export function defaultAvatar(name) {
    let h = 0;
    for (const c of name)
        h = (h * 31 + c.charCodeAt(0)) >>> 0;
    return DEFAULT_AVATARS[h % DEFAULT_AVATARS.length];
}
